import { AppStatus } from '@/redux'
import { getFirebase } from '../../firebaseApp'
import { ERRORS, isEmailAvailable, Profile } from './views'
import { warnEmailInUse } from './utils'
import { useProfile, useUpdateProfile } from './useProfile'

export function useEdit() {

  const profile = useProfile()
  const updateProfile = useUpdateProfile()

  const editProfile = async (data: Partial<Profile>) => {

    AppStatus.set('loading')
    try {
      const emailAddressChanged = !!data.email?.trim() && (data?.email?.trim() !== profile.data.email.trim())

      if (emailAddressChanged) {
        const emailAvailable = await isEmailAvailable(data.email)

        if (!emailAvailable) {
          warnEmailInUse()
          throw ERRORS.emailInUse
        }
        try {
          const firebase = await getFirebase()

          await firebase.auth().currentUser.updateEmail(data.email)
        } catch (e) {
          if (e.code === 'auth/requires-recent-login') {
            throw ERRORS.reautenticationRequired
          }
        }
      }
      await updateProfile.mutateAsync(data)

      setTimeout(() => {
        AppStatus.set('done')
      }, 1000)

    } catch (e) {
      logger.error('Failed to edit profile', e, 'Auth')
      AppStatus.set('idle')
      throw e

    }

  }

  return { editProfile }
}
